module.exports = __webpack_public_path__ + "img/banner7.3e338ef6.png";